export default __webpack_public_path__ + "static/media/google-auth-white.af0120e0.svg";